import DOMParser from 'react-native-html-parser';
import { RESIZER_REPLY_EXTRA_SPACE, BASE_MULTIPLE } from '../Constants';
import { getFriendlyOrDiscourseUsername } from '../utils/helpers';
const useDomParser = () => {
  const getParser = () => {
    return new DOMParser.DOMParser();
  };
  const submitAtMentions = (parser, sourceHTML) => {
    // find @mention spans, replace data-username with data-value

    const parsed = parser.parseFromString(sourceHTML, 'text/html');
    if (parsed) {
      const mentions = parsed.getElementsByClassName('mention');
      if (mentions) {
        const list = Array.prototype.filter.call(mentions, el => {
          return el.nodeName === 'span';
        });
        for (let i = 0; i < list.length; i++) {
          // <span class="mention" data-username="frn_member.1000" data-value="Lauren W">
          const item = list[i]; // <span contenteditable="false">
          // children : <span class="ql-mention-denotation-char">@</span>Lauren W</span></span></p>
          const mentionUser = getMentionUser(item);
          /*
            TODO: update var names so that they're less confusing
            currently they're not logging values as they're supposed to
            but regarding functionality, it's working just as expected
            case 1/2
          */
          const friendlyUsername = getFriendlyOrDiscourseUsername(mentionUser, 'friendly');
          const discourseUsername = getFriendlyOrDiscourseUsername(mentionUser, 'discourse');
          setAttribute(item, 'data-username', friendlyUsername);
          setAttribute(item, 'data-value', discourseUsername);
          item.textContent = '@' + discourseUsername;
        }

        // substituteBeforePost data.raw <p> - <span class="mention" data-username="Anthony J" data-value="frn_member.1407">@frn_member.1407</span></p>
        sourceHTML = parsed.toString();
      }
    }
    return sourceHTML;
  };
  const getMentionUser = item => {
    const user = {
      username: '',
      name: ''
    };
    if (item) {
      const attrs = item.attributes;
      for (let j = 0; j < attrs.length; j++) {
        const attr = attrs[j];
        if (attr.nodeName === 'data-username') user.username = attr.nodeValue; // username for discourse
        if (attr.nodeName === 'data-value') user.name = attr.nodeValue; // customer-facing name
      }
    }
    return user;
  };
  const setAttribute = (item, name, value) => {
    if (item) {
      const attrs = item.attributes;
      for (let i = 0; i < attrs.length; i++) {
        const attr = attrs[i];
        if (attr.nodeName === name) {
          attr.value = value;
          attr.nodeValue = value;
          break;
        }
      }
    }
  };
  const displayAtMentions = (parser, sourceHTML) => {
    // find @mention spans, replace data-value with data-username
    const parsed = parser.parseFromString(sourceHTML, 'text/html');
    if (parsed) {
      const mentions = parsed.getElementsByClassName('mention');
      transformAtMentionsAnchors(mentions);
      sourceHTML = parsed.toString();
    }
    return sourceHTML;
  };
  const getMentionElementType = mentions => {
    // console.log('getMentionElementType', 'mentions', mentions);
    if ((mentions === null || mentions === void 0 ? void 0 : mentions.length) > 0) {
      return mentions[0].nodeName;
    }
    return '';
  };
  const transformAtMentionsAnchors = mentions => {
    const list = Array.prototype.filter.call(mentions, el => {
      return el.nodeName === 'a';
    });
    for (let i = 0; i < list.length; i++) {
      // item: <a class="mention" data-username="Anthony J" data-value="frn_member.1407" href="/u/frn_member.1407">@frn_member.1407</a>
      const item = list[i];
      const mentionUser = getMentionUser(item);
      item.setAttribute('href', '#');
      /*
        TODO: update var names so that they're less confusing
        currently they're not logging values as they're supposed to
        but regarding functionality, it's working just as expected
        case 2/2
      */
      const friendlyUsername = getFriendlyOrDiscourseUsername(mentionUser, 'friendly');
      const discourseUsername = getFriendlyOrDiscourseUsername(mentionUser, 'discourse');
      setAttribute(item, 'data-username', friendlyUsername);
      setAttribute(item, 'data-value', discourseUsername);
      item.textContent = '@' + discourseUsername;
    }
  };
  const displayEditAtMentions = (parser, sourceHTML) => {
    // find @mention elements, swap data-username and data-value attribute values

    const parsed = parser.parseFromString(sourceHTML, 'text/html');
    if (parsed) {
      // get mentions
      const mentions = parsed.getElementsByClassName('mention');
      // continue if mentions found
      if (mentions !== null && mentions !== void 0 && mentions.length) {
        // get mention node type
        const mentionElementType = getMentionElementType(mentions);
        // if anchors found do transformation
        if (mentionElementType === 'a') {
          transformAtMentionsAnchors(mentions);
          sourceHTML = parsed.toString();
        }
      }
    }
    return sourceHTML;
  };
  const normalizeImages = (parser, sourceHTML, containerWidth, type = 'topic') => {
    if (parser) {
      const parsed = parser.parseFromString(sourceHTML, 'text/html');
      if (parsed) {
        const images = parsed.getElementsByTagName('img');
        if (images) {
          for (let i = 0; i < images.length; i++) {
            const image = images[i];
            const parent = image.parentNode;

            // remove anchor children (including text) except image
            if (parent.nodeName === 'a') {
              while (parent.childNodes.length > 1) {
                parent.removeChild(parent.lastChild);
              }
            }

            // get width/height values of image
            let imageWidth = +image.getAttribute('width');
            let imageHeight = +image.getAttribute('height');

            // set width percentage to determine max width allowable
            let imageWidthMax = containerWidth * BASE_MULTIPLE;

            // adjust replies for smaller container
            if (type === 'reply') {
              const contentWidth = containerWidth - RESIZER_REPLY_EXTRA_SPACE;
              const imageToContentMultiple = contentWidth / containerWidth;
              const currentReplyMultiple = imageToContentMultiple * BASE_MULTIPLE;
              imageWidthMax = containerWidth * currentReplyMultiple;
            }

            // reset width and height if width is larger than threshold
            if (imageWidth > imageWidthMax) {
              const heightPercentage = imageHeight / imageWidth;
              image.setAttribute('width', Math.floor(imageWidthMax));
              image.setAttribute('height', Math.floor(heightPercentage * imageWidthMax));
            }
          }
          sourceHTML = parsed.toString();
        }
      }
    }
    return sourceHTML;
  };
  return {
    getParser,
    normalizeImages,
    displayAtMentions,
    submitAtMentions,
    getMentionElementType,
    displayEditAtMentions
  };
};
export { useDomParser };
//# sourceMappingURL=useDomParser.js.map